import { Component, Inject, Input } from '@angular/core';
import { IWindowSnare } from '../../../models/interfaces/i-window-snare.interface';
import { Logo } from '../../../models/themes/logo.model';
import { WINDOW } from '../../../shared-providers/window.providers';
import { SessionStorageService } from '../../../shared-services/services/session-storage.service';
import { ThemeService } from '../../../shared-services/services/theme.service';
import { MarginalDirective } from '../marginal';
import { IBackgroundImageStyle } from '../../../models/interfaces/i-background-image-style.interface';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class HeaderComponent extends MarginalDirective {

    public logo: Logo;

    @Input() showAppName = true;
    @Input() isSmaller = false;
    @Input() appName: string;

    constructor(
        themeService: ThemeService,
        sessionStorageService: SessionStorageService,
        @Inject(WINDOW) window: IWindowSnare) {
        super(themeService, sessionStorageService, window);
    }

    public themeAvailable(): void {
    this.logo = this.theme.themePrimaryLogo;
    }

    public getSubscriptionLogo(): IBackgroundImageStyle {
        if (this.theme) {
            return {
                'background-image': `url(${encodeURI(this.theme.themeSecondaryLogo.url)})`
            };
        }
    }
}
